import React, { Component } from "react";
import PropTypes from "prop-types";

import { Row, Col } from "reactstrap";
import ModalUploadProvider, {
  ModalUploadContext
} from "../Providers/ModalUpload";
import { LogsServiceAPI } from "../Util/logsService";
import Header from "./Header";
import Footer from "./Footer";
import Cookies from "js-cookie";

import "./Layout.scss";
import { ModalAvisoProvider } from "../Context/ModalAvisoContext";

class Layout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: false,
      modalUpload: false
    };

    // Consulta os acessos na solução para enviar para a Api do Painel de Acessos do Principal
    let logsServiceApi = new LogsServiceAPI();
    logsServiceApi.salvarLog(Cookies.get("bG9naW4"), 353, 1);
  }

  onCollapse = () => {
    let active = !this.state.collapsed;
    this.setState({ collapsed: active });
  };

  render() {
    return (
      <ModalAvisoProvider>
        <ModalUploadProvider>
          <ModalUploadContext.Consumer>
            {modalUpload => {
              this.openModalUpload = modalUpload.openModal;
            }}
          </ModalUploadContext.Consumer>
          <div
            id="layout"
            className="h-100"
            onDragOverCapture={() => this.openModalUpload()}
          >
            <div id="general" className="h-100">
              <Header />
              <Row id="main">
                <Col>
                  <Row className="h-100">
                    <Col sm={11} className="main-outside col" />
                    <Col sm={1} className="skew-left col main-inside" />
                  </Row>
                </Col>
                <Col sm={9} className="col">
                  <div id="content">{this.props.children}</div>
                </Col>
                <Col>
                  <Row className="h-100">
                    <Col sm={1} className="skew-right col main-inside" />
                    <Col sm={11} className="col main-outside" />
                  </Row>
                </Col>
              </Row>
              <Footer />
            </div>
          </div>
        </ModalUploadProvider>
      </ModalAvisoProvider>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
